import {
  QuestionFormat,
  QuestionTypePreset,
  QUESTION_TYPE_PRESETS,
  QUESTION_TYPE_PRESET_MAP,
  type QuestionTypePresetConfig,
  type QuestionTypePresetStemShape,
} from '@eps/shared-types';

export type StemToggles = QuestionTypePresetStemShape;

export {
  QuestionFormat,
  QuestionTypePreset,
  QUESTION_TYPE_PRESETS,
  QUESTION_TYPE_PRESET_MAP,
  type QuestionTypePresetConfig,
};

export function inferPresetFromQuestion(
  stem: { text: string; imageUrl: string; audioUrl: string },
  options: { format: string }[],
): { presetId: QuestionTypePreset | null; toggles: StemToggles; optionFormat: QuestionFormat } {
  const toggles: StemToggles = {
    text: !!stem.text,
    image: !!stem.imageUrl,
    audio: !!stem.audioUrl,
  };
  const optionFormat = (options[0]?.format as QuestionFormat) || QuestionFormat.TEXT;

  if (!toggles.text && !toggles.image && !toggles.audio) {
    return { presetId: null, toggles, optionFormat };
  }

  const match = QUESTION_TYPE_PRESETS.find(
    (preset) =>
      preset.stem.text === toggles.text &&
      preset.stem.image === toggles.image &&
      preset.stem.audio === toggles.audio &&
      preset.optionFormat === optionFormat,
  );

  return { presetId: match?.id ?? null, toggles, optionFormat };
}
